module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-testimonial-5.a636cee5.webp";